import { render, staticRenderFns } from "./IconToggle.vue?vue&type=template&id=070ddb1c&"
import script from "./IconToggle.vue?vue&type=script&lang=js&"
export * from "./IconToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070ddb1c')) {
      api.createRecord('070ddb1c', component.options)
    } else {
      api.reload('070ddb1c', component.options)
    }
    module.hot.accept("./IconToggle.vue?vue&type=template&id=070ddb1c&", function () {
      api.rerender('070ddb1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workPacks/components/customComponents/IconToggle.vue"
export default component.exports